import { useEffect } from 'react';
import copy from 'clipboard-copy';
import { ModalBlock } from '@sb1/ffe-modals-react';
import { BodyText, Heading2 } from '@sb1/ffe-core-react';
import Image from '../../../components/image/Image';
import Spinner from '../../../components/spinner/Spinner';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import NativeShareButton from '../NativeShareButton';
import { InputWithCopyButton } from '../../../components/input-with-copy/InputWithCopyButton';
import List from '../../../components/text/List';
import styles from './ShareInstructionsModal.module.less';
import useImgOnLoad from '../../../components/hooks/useImgOnLoad';

export default function FacebookShareInstructionsModalBlock({
    urlToShare,
    project,
    trackingProperties,
    onBack,
    tradingCardImageUrl,
}) {
    const [ref, loaded, onLoad] = useImgOnLoad();

    const imageSrc = tradingCardImageUrl ? tradingCardImageUrl : project.img_url;

    useEffect(() => {
        copy(urlToShare);
    }, [urlToShare]);

    return (
        <ModalBlock>
            <Heading2 id="share-modal-title">Del på Facebook</Heading2>
            <div className={`${styles.container} ${styles.imageShare}`}>
                {!loaded && <Spinner />}
                <div className={styles.photoContainer}>
                    <Image
                        className={`${styles.previewPhoto} ${styles.imageShare} ${loaded && styles.border}`}
                        src={imageSrc}
                        title={'Del på Facebook'}
                        alt={'Delingsbilde til Facebook'}
                        ref={ref}
                        onLoad={onLoad}
                    />
                </div>
                <BodyText className={styles.guideTitle}>
                    <List tag="ol">
                        <li>Kopiér lenken under</li>
                        <li>Del på Facebook og lim inn lenken under</li>
                    </List>
                </BodyText>
            </div>
            <div>
                <InputWithCopyButton
                    label={'Lenke til spleisen'}
                    prettyUrlToShare={urlToShare}
                    trackEventFunction={() =>
                        trackEvent('support', 'share-after-instructions-copy', {
                            channel: 'facebook',
                            ...trackingProperties,
                        })
                    }
                />
            </div>
            <NativeShareButton
                onBack={onBack}
                text={'Åpne Facebook'}
                shareImageUrl={imageSrc}
                trackEventFunction={() =>
                    trackEvent('support', 'share-after-instructions', {
                        channel: 'facebook',
                        ...trackingProperties,
                    })
                }
            />
        </ModalBlock>
    );
}
